"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3688],{

/***/ 63688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ColazType; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72462);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84849);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55791);
/* harmony import */ var _ViewPort__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33030);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);








function ColazType(props) {
    var dateLocale = (0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useLocale */ .bU)();
    var t = (0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useT */ .NT)();
    var builder = props.builder;
    var content = props.content;
    var articles = props.articles;
    var container_class = "container-fluid";
    if (props.type == "blog") {
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(builder.builder_news_view_width)) {
            container_class = builder.builder_news_view_width;
        }
    } else if (props.type == "category") {
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(content.category_view_width)) {
            container_class = content.category_view_width;
        }
    }
    var counter = 1;
    var skeletonArticles = [];
    for(var i = 0; i < 6; i++){
        var col_class = void 0;
        var currentRow = Math.floor(i / 3);
        if (currentRow % 2 == 0) {
            if (counter === 1) {
                col_class = "col-12 col-sm-12 col-md-12 col-lg-6";
            } else {
                col_class = "col-6 col-sm-6 col-md-6 col-lg-3";
            }
            if (counter === 3) {
                counter = 1;
            } else {
                counter++;
            }
        } else {
            if (counter === 3) {
                col_class = "col-12 col-sm-12 col-md-12 col-lg-6";
            } else {
                col_class = "col-6 col-sm-6 col-md-6 col-lg-3";
            }
            if (counter === 3) {
                counter = 1;
            } else {
                counter++;
            }
        }
        skeletonArticles.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat(col_class, " p-0"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                height: 400,
                className: "col-12 b-rad-md"
            })
        }, i.toString()));
    }
    counter = 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(container_class, " ") + (container_class == "container-fluid" ? "p-0" : ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "row w-100 m-0",
            children: props.loadingArticles ? skeletonArticles : articles != undefined && articles.length > 0 && articles.map(function(article, key) {
                var col_class = "col-12 col-sm-12 col-md-12 col-lg-6";
                var ar_class = "ar-2-1";
                var currentRow = Math.floor(key / 3);
                if (articles.length > 6) {
                    if (currentRow % 2 == 0) {
                        if (counter === 1) {
                            col_class = "col-12 col-sm-12 col-md-12 col-lg-6";
                            ar_class = "ar-2-1";
                        } else {
                            col_class = "col-6 col-sm-6 col-md-6 col-lg-3";
                            ar_class = "ar-1-1";
                        }
                        if (counter === 3) {
                            counter = 1;
                        } else {
                            counter++;
                        }
                    } else {
                        if (counter === 3) {
                            col_class = "col-12 col-sm-12 col-md-12 col-lg-6";
                            ar_class = "ar-2-1";
                        } else {
                            col_class = "col-6 col-sm-6 col-md-6 col-lg-3";
                            ar_class = "ar-1-1";
                        }
                        if (counter === 3) {
                            counter = 1;
                        } else {
                            counter++;
                        }
                    }
                } else {
                    switch(articles.length){
                        case 1:
                            break;
                        case 2:
                        case 3:
                            if (key > 0) {
                                col_class = "col-6 col-sm-6 col-md-6 col-lg-3";
                                ar_class = "ar-1-1";
                            }
                            break;
                        case 4:
                            col_class = "col-12 col-sm-12 col-md-12 col-lg-6";
                            ar_class = "ar-2-1";
                            break;
                        case 5:
                            if (key > 2) {
                                col_class = "col-12 col-sm-12 col-md-12 col-lg-6";
                                ar_class = "ar-2-1";
                            } else if (key > 0) {
                                col_class = "col-6 col-sm-6 col-md-6 col-lg-3";
                                ar_class = "ar-1-1";
                            }
                            break;
                        case 6:
                            if (key > 4) {
                                col_class = "col-12 col-sm-12 col-md-12 col-lg-6";
                                ar_class = "ar-2-1";
                            } else if (key > 2) {
                                col_class = "col-6 col-sm-6 col-md-6 col-lg-3";
                                ar_class = "ar-1-1";
                            } else if (key > 0) {
                                col_class = "col-6 col-sm-6 col-md-6 col-lg-3";
                                ar_class = "ar-1-1";
                            }
                            break;
                        default:
                            col_class = "col-6 col-sm-6 col-md-6 col-lg-3";
                            ar_class = "ar-1-1";
                            break;
                    }
                }
                col_class += " no-padding hover-zoom";
                col_class += article.show_in_different_page || _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(article.description) ? " cursor-pointer" : "";
                ar_class += " bg-master-dark";
                var created = (0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_2__/* .formatMomentDate */ .XY)(dateLocale, new Date(article.created * 1000), "dddd Do MMMM");
                var title = props.articlesContentType == "blog" ? created : article.title;
                var subtitle = props.articlesContentType == "article" ? article.subtitle : props.articlesContentType == "blog" ? article.title : article.description;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ViewPort__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    parentClassName: col_class,
                    skeletonItem: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        height: 200,
                        className: "col-12 b-rad-md"
                    }),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                        href: props.updateHref(article),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            onClick: function() {
                                return props.clickHandler(article);
                            },
                            className: props.setClass(article, col_class),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "inner bottom-left text-left padding-30",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                            className: "block-title text-white m-0",
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                            className: "bold text-white line-clamp-2 m-t-5 m-b-0 hidden-xs",
                                            children: subtitle
                                        }),
                                        article.has_description == "1" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "font-arial fs-11 text-white muted m-t-5 mb-0 hidden-xs",
                                                children: t("common.readMoreShort")
                                            })
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "font-arial fs-11 text-white muted m-t-5 mb-0 hidden-xs",
                                                children: "\xa0"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: ar_class + " brightness-filter-80",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "psuedo-background",
                                        "data-pages-bg-image": true,
                                        children: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(article.image) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                            className: "psuedo-background-img",
                                            layout: "fill",
                                            sizes: "75vw",
                                            quality: "75",
                                            src: article.image,
                                            alt: article.caption ? _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].removeEmojis */ .Z.removeEmojis(article.caption) : _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].removeEmojis */ .Z.removeEmojis(article.title) || "Post Img",
                                            objectFit: "cover",
                                            placeholder: "blur",
                                            blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                        })
                                    })
                                })
                            ]
                        }, article.id.toString())
                    })
                }, article.id.toString());
            })
        })
    });
}


/***/ })

}]);